var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-[2px] bg-gray-500 w-full relative"},[_c('div',{staticClass:"absolute h-[2px] bg-gray-100 left-0",style:({ width: _vm.progress * 10 + '%' })})])
}
var staticRenderFns = []

export { render, staticRenderFns }